export const DEFAULT = 'DEFAULT'
export const CHATBOT = 'CHATBOT'
export const WIDGET = 'WIDGET'
export const FACEBOOK = 'FACEBOOK'
export const WHATSAPP = 'WHATSAPP'
export const TWILIO = 'TWILIO'
